import PublicationEdit from "./PublicationEdit";
import PublicationSuccess from "./PublicationSuccess";

export const editPersonal = [
    {
        title: 'publication_personal_check_entered_data',
        progress: { title: 'publication_personal_progress_check_data', step: 2 },
        component: PublicationEdit, valid: true, required: true,
    },
    {
        progress: { title: 'publication_personal_progress_thanks', step: 3 },
        component: PublicationSuccess, valid: true, required: true,
    },
];

export default editPersonal;
